import { AuthService } from './services/auth'
import { ENDPOINTS } from '@shared/utils/constant'
import { lazyImportSdkTs } from '@shared/utils/lib'
import { injToken, usdcToken } from '@shared/data/token'
import { TC_ENDPOINTS, WS_PRICE_ORACLE_API_KEY } from '@/app/utils/constants'
import type {
  TcAbacusGrpcApi,
  ChainGrpcWasmApi,
  IndexerGrpcRFQApi,
  ChainGrpcAuthZApi,
  IndexerGrpcRfqGwApi,
  IndexerGrpcWeb3GwApi,
  IndexerGrpcArchiverApi,
  IndexerGrpcWsPriceOracleApi,
  IndexerGrpcTcDerivativesApi
} from '@injectivelabs/sdk-ts'

// fixes a circular dependency
import('@shared/service/tokenStaticFactory').then(({ tokenStaticFactory }) => {
  tokenStaticFactory.mapRegistry([injToken, usdcToken])
})

// Services
// 'https://testing.abacus.injective.cooking/grpc'
// https://k8s.mainnet.eu.abacus.injective.network/grpc

export const getTcAbacusGrpcApi = async () =>
  lazyImportSdkTs<TcAbacusGrpcApi>({
    className: 'TcAbacusGrpcApi',
    endpoint: TC_ENDPOINTS.tcAbacus
  })

export const getChainGrpcWasmApi = async () =>
  lazyImportSdkTs<ChainGrpcWasmApi>({
    className: 'ChainGrpcWasmApi',
    endpoint: ENDPOINTS.grpc
  })

export const getAuthZApi = async () =>
  lazyImportSdkTs<ChainGrpcAuthZApi>({
    className: 'ChainGrpcAuthZApi',
    endpoint: ENDPOINTS.grpc
  })

export const getIndexerGrpcArchiverApi = async () =>
  lazyImportSdkTs<IndexerGrpcArchiverApi>({
    className: 'IndexerGrpcArchiverApi',
    endpoint: TC_ENDPOINTS.archiver
  })

export const getIndexerGrpcTcDerivativesApi = async () =>
  lazyImportSdkTs<IndexerGrpcTcDerivativesApi>({
    className: 'IndexerGrpcTcDerivativesApi',
    endpoint: TC_ENDPOINTS.tcDerivatives
  })

export const getIndexerGrpcRfqGwApi = async () =>
  lazyImportSdkTs<IndexerGrpcRfqGwApi>({
    className: 'IndexerGrpcRfqGwApi',
    endpoint: TC_ENDPOINTS.rfqGateway
  })

export const getIndexerGrpcWeb3GwApi = async () =>
  lazyImportSdkTs<IndexerGrpcWeb3GwApi>({
    className: 'IndexerGrpcWeb3GwApi',
    endpoint: ENDPOINTS.web3gw || ''
  })

export const getIndexerGrpcRfqApi = async () =>
  lazyImportSdkTs<IndexerGrpcRFQApi>({
    className: 'IndexerGrpcRFQApi',
    endpoint: TC_ENDPOINTS.rfq
  })

let indexerGrpcWsPriceOracleApi: undefined | IndexerGrpcWsPriceOracleApi
let indexerGrpcWsPriceOracleApiPromise:
  | undefined
  | Promise<IndexerGrpcWsPriceOracleApi>

export const getIndexerGrpcWsPriceOracleApi = async () => {
  if (indexerGrpcWsPriceOracleApi) {
    return indexerGrpcWsPriceOracleApi
  }

  if (indexerGrpcWsPriceOracleApiPromise) {
    return indexerGrpcWsPriceOracleApiPromise
  }

  indexerGrpcWsPriceOracleApiPromise =
    import('@injectivelabs/sdk-ts/client/indexer')
      .then(({ IndexerGrpcWsPriceOracleApi }) => {
        const api = new IndexerGrpcWsPriceOracleApi(TC_ENDPOINTS.wsPriceOracle)

        if (WS_PRICE_ORACLE_API_KEY) {
          api.setMetadata({
            'x-api-key': WS_PRICE_ORACLE_API_KEY
          })
        }

        indexerGrpcWsPriceOracleApi = api

        return api
      })
      .catch((error) => {
        indexerGrpcWsPriceOracleApiPromise = undefined

        throw error
      })

  return indexerGrpcWsPriceOracleApiPromise
}

export { localStorage } from './services/localStorage'

export const authService = new AuthService()
